/*
  Apple Books product rails: page-at-a-time arrows.

  The rails are Dawn's slider-component, whose arrow handler advances by the
  button's data-step. Any fixed step is wrong at some width - four at a time
  skips past most of a phone's row, one at a time crawls on a desktop. So the
  step is set to however many cards the rail is showing at the moment of the
  click, which Dawn itself recalculates on every resize (slidesPerPage).

  One delegated capture listener serves every rail on the page. Capture runs
  before Dawn's own listener on the button, so the step is in place by the
  time Dawn reads it. The guard stops a second rail's script tag wiring it
  twice.
*/
(function () {
  if (window.apRailWired) return;
  window.apRailWired = true;

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest('.ap-rail .ap-rail__arrow');
      if (!button) return;
      var rail = button.closest('slider-component');
      var perPage = rail && rail.slidesPerPage;
      if (perPage > 0) button.dataset.step = perPage;
    },
    true
  );
})();
